var _ = require('underscore'),
    DerivedWordModels = require('./DerivedPositionalWords');


var DocumentTextModel = function() {

    // Could also make these a classes or collection ( they are made of models ) ...

    this.originalWordModels = null; // doc level array containing references to all the wdModels from the pages' positionalTextDataModels in order ( maybe we rid the latter )
    this.derivedWordModels = null; // 'derived words' from their originals; combo words with dashed as one, remove empty words or those with only white-space
    this.lineModels = null; // doc level array referencing line models from positionalTextDataModels
    this.zoneModels = null; // doc level array referencing zones models from positionalTextDataModels

    return this;
};

_.extend( DocumentTextModel.prototype, {


    // Further processing of the page text data models augenting for ids at the document level.
    // Now also create an array of original word models (document level) to facilitate getting original sub-words from words on > 1 page
    // TODO: maybe we rid positionalTextDataModels -- they aren't really needed anymore --
    // and should parse at the page level ...
    // ... just store at the doc level w/functions
    // Setting up a doc level id reference for the data-models
    // Obviously not the fastest way to parse given already parsing with the page data models, but use
    // this for now to not break ...

    create: function( documentModel ) {

        var pagesWithPositionalData = documentModel.pageCollection.pagesWithPositionalData(), // (already parsed)
            originalWdModels = this.originalWordModels = [],
            originalLineModels = this.lineModels = [],
            originalZoneModels = this.zoneModels = [],
            nZones = 0,
            nLines = 0,
            nWords = 0;

        _.each( pagesWithPositionalData, function( page ) {

            var pageTextDataModel = page.getPositionalTextDataModel();

            pageTextDataModel.zones.each( function( zone ) {

                zone.set({
                    id: nZones
                });
                originalZoneModels.push( zone );

                _.each( zone.getPageLevelLineIds(), function( pgLineId ) {

                    var line = pageTextDataModel.getLine( pgLineId );

                    line.set({
                        id: nLines
                    });

                    originalLineModels.push( line );

                    _.each( line.getPageLevelWordIds(), function( pgWordId ) {

                        var word = pageTextDataModel.getWord( pgWordId );

                        word.set({
                            id: nWords,
                            docLevelLineId: nLines,
                            docLevelZoneId: nZones
                        });

                        originalWdModels.push( word );

                        line.addDocLevelWordId( nWords );
                        zone.addDocLevelLineId( nLines );
                        zone.addDocLevelWordId( nWords );

                        nWords++;

                    });

                    nLines++;

                });

                nZones++;

            });

        });


        // Create the derived word models -- we search off these
        this.derivedWordModels = new DerivedWordModels( pagesWithPositionalData );

        // Set a link from the derive sub-words their original parent
        _.each( this.derivedWordModels.getDerivedWords(), function( derivedWord ) {

            var derivedWdId = derivedWord.id;

            _.each( derivedWord.get('subWordReferences'), function(subWordReference) {

                // Wrap original in collection/class ??
                var originalWdModel = _.find( originalWdModels, function(m) {
                    return m.id === subWordReference.originalId;
                });

                originalWdModel.set( 'derivedParentId', derivedWdId );

            });

        });

        return this;

    },

    getOriginalWordModels: function() {
        return this.originalWordModels;
    },

    // Note: these can be derived and will have different ids than originals on the positional page models
    getDerivedWordModels: function() {
        return this.derivedWordModels.getWords();
    },

    getLineModels: function() {
        return this.lineModels;
    },

    getZoneModels: function() {
        return this.zoneModels;
    },

    getOriginalWordModelById: function( docLevelWdId ) {

        return _.find( this.getOriginalWordModels(), function( word ) {
            return word.id === docLevelWdId;
        });
    }

});



module.exports = DocumentTextModel;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/positionalTextModels/DocumentTextModel.js
 ** module id = 406
 ** module chunks = 0
 **/